<template>
  <div class="container">
    <div v-if="genericErrorState.isThereAGenericServerError" class="alert alert-danger">
      Server Error. Contact the administrator.
      <button type="button" class="close" @click="dismissGenericErrorMessage()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div v-if="configServerError" class="alert alert-danger">
      Something went terribly wrong. Contact the administrator.
    </div>
    <div v-for="productLine in configErrors" class="alert alert-warning">
      Missing configuration for {{ productLine }}.
    </div>
  </div>
</template>

<script>
  import FormConfigService from '../service/FormConfigService';
  import {genericServerErrorStore} from '../service/GenericServerErrorStore';

  export default {
    name: 'GlobalErrorMessages',
    data() {
      return {
        configErrors: FormConfigService.getMissingConfigs(),
        configServerError: FormConfigService.getServerError(),
        genericErrorState: genericServerErrorStore.state
      };
    },
    methods: {
      dismissGenericErrorMessage: function () {
        this.genericErrorState.setGlobalError(false);
      }
    }
  }
</script>

<style scoped>
  .alert:first-child {
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/GlobalErrorMessages.vue